import styled, { css } from "styled-components";

export const StyledDiagnosticsScrollableArea = styled.div<{
  $height: number
  $y: number
  $withTransition: boolean
}>`
  height: ${({ $height }) => `${$height}px`};
  ${({ $y, $withTransition }) => css`
    transition: ${$withTransition ? 'transform var(--transition-slow)' : 'none'};
    transform: translateY(${`${$y}px`});
  `}
`;